<template>
  <section
    class="page-container"
  >
    <div class="flex flex-align-center flex-sb-center">
      <div class="total">
        <div
          v-for="(value,i) in statistics"
          :key="i"
          class="item">
          <span class="num">{{value.val}}</span>
          <span>{{value.name}}</span>
        </div>
      </div>
    </div>
    <div class="filter-top">
      <v-input
        v-model="search"
        :prefixIcon="'el-icon-search'"
        placeholder="Policy No., Cover Note No., HCID, Endorsement No., Customer Name, Contact, Referrer, VRD"
        @keyEnter="filterData" />
    </div>

    <div
      class="filter-bar pointer"
      :class="{
        'blue-bg': diff,
        'border-bottom-radius': !showFilterCard}"
      @click="handleShowFilter">
      <div class="main-left">
        <div class="left">
          <font-awesome-icon
            icon="filter"
            class="icon icon-filter"></font-awesome-icon>
          <span class="text">Filter</span>
        </div>
        <div class="filter-status">
          <span
            v-for="(item, i) in statusList"
            :key="i"
            class="status-item">
            <span class="status-title">
              {{item.title}}:
            </span>
            <span class="content">
              {{item.content}}
            </span>
          </span>
        </div>
      </div>
      <div class="right">
        <div
          v-if="diff"
          class="translucence"></div>
        <div class='right-content'>
          <font-awesome-icon
            v-show="diff"
            icon="rotate-left"
            class="icon icon-rotate pointer"
            @click.stop="resetFilter"></font-awesome-icon>
          <font-awesome-icon
            v-if="showFilterCard"
            icon="square-minus"
            class="icon pointer"
          ></font-awesome-icon>
          <font-awesome-icon
            v-else
            icon="square-plus"
            class="icon pointer"
          ></font-awesome-icon>
        </div>
      </div>
    </div>
    <div
      v-show="showFilterCard"
      class="filter-card border-bottom-radius">
      <div class="filter-main">
        <div class="filter-left">
          <div class="form-item">
            <span>Creation Date</span>
            <v-date-picker
              v-model="date"
              type="daterange"
              @change="filterData" />
          </div>
          <div class="form-item">
            <span>Issue Date</span>
            <v-date-picker
              v-model="issue_date"
              type="daterange"
              @change="filterData" />
          </div>
          <div class="form-item">
            <span>Effective Start Date</span>
            <v-date-picker
              v-model="effective_date"
              type="daterange"
              @change="filterData" />
          </div>
        </div>
        <div
          class="filter-middler">
          <div class="form-item">
            <span>
              Status
              <span
                class="all"
                @click="handlerSelectAll('stts')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('stts')">None</span>            </span>
            <v-checkbox-group
              v-model="stts"
              :list="statusOptions"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="circle"
                    :class="{
                      'red': item.id == 0,
                      'orange-light': item.id == 1,
                      'yellow-dark': item.id == 2,
                      'blue': item.id == 3,
                      'green': item.id == 4
                    }"></span>
                  <span>{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
          <div class="form-item">
            <span>
              Effectiveness
              <span
                class="all"
                @click="handlerSelectAll('effe')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('effe')">None</span>            </span>
            <v-checkbox-group
              v-model="effe"
              :list="effeOptions"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="span-options"
                    :class="{
                      'gray': item.id == 1,
                      'green': item.id == 2,
                      'red': item.id == 3
                    }">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
        </div>
        <!--        <div-->
        <!--          class="filter-right"-->
        <!--        >-->
        <!--          <div class="form-item">-->
        <!--            <span>-->
        <!--              Eligible-->
        <!--              <span-->
        <!--                class="all"-->
        <!--                @click="handlerSelectAll('stts')">All</span>-->
        <!--              <span-->
        <!--                class="all"-->
        <!--                @click="handlerNoneAll('stts')">None</span>            </span>-->
        <!--            <v-checkbox-group-->
        <!--              v-model="stts"-->
        <!--              :list="statusOptions"-->
        <!--              :isColumn="false"-->
        <!--              @change="filterData">-->
        <!--            </v-checkbox-group>-->
        <!--          </div>-->
        <!--          <div class="form-item">-->
        <!--            <span>-->
        <!--              Reached Target-->
        <!--              <span-->
        <!--                class="all"-->
        <!--                @click="handlerSelectAll('effe')">All</span>-->
        <!--              <span-->
        <!--                class="all"-->
        <!--                @click="handlerNoneAll('effe')">None</span>            </span>-->
        <!--            <v-checkbox-group-->
        <!--              v-model="effe"-->
        <!--              :list="effeOptions"-->
        <!--              :isColumn="false"-->
        <!--              @change="filterData">-->
        <!--            </v-checkbox-group>-->
        <!--          </div>-->
        <!--          <div class="form-item">-->
        <!--            <span>-->
        <!--              Eligible Policy-->
        <!--              <span-->
        <!--                class="all"-->
        <!--                @click="handlerSelectAll('effe')">All</span>-->
        <!--              <span-->
        <!--                class="all"-->
        <!--                @click="handlerNoneAll('effe')">None</span>            </span>-->
        <!--            <v-checkbox-group-->
        <!--              v-model="effe"-->
        <!--              :list="effeOptions"-->
        <!--              :isColumn="false"-->
        <!--              @change="filterData">-->
        <!--            </v-checkbox-group>-->
        <!--          </div>-->
        <!--          <div class="form-item">-->
        <!--            <span>-->
        <!--              Rewarded-->
        <!--              <span-->
        <!--                class="all"-->
        <!--                @click="handlerSelectAll('effe')">All</span>-->
        <!--              <span-->
        <!--                class="all"-->
        <!--                @click="handlerNoneAll('effe')">None</span>            </span>-->
        <!--            <v-checkbox-group-->
        <!--              v-model="effe"-->
        <!--              :list="effeOptions"-->
        <!--              :isColumn="false"-->
        <!--              @change="filterData">-->
        <!--            </v-checkbox-group>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="filter-last">
          <div class="form-item">
            <span>
              Tag
              <span
                class="all"
                @click="handlerSelectAll('tags')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('tags')">None</span>            </span>
            <v-checkbox-group
              v-model="tags"
              :list="tagsOptions"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="span-options"
                    :class="{
                      'gold': item.id == 1,
                      'blue': [2,16,64,256].includes(item.id),
                      'orange': item.id == 4,
                      'black': [8,32,128].includes(item.id),
                      'red': [512].includes(item.id),
                      'gray': [1024, 2048].includes(item.id)
                    }">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
        </div>
      </div>
    </div>

    <div class="transparent">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-row-class-name="handleTableClass"
        @row-click="rowClick">
        <el-table-column
          width="69px"
          align="center">
          <template #default="{row}">
            <div
              class="flex-algin"
            >
              <p class="icon icon-text">
                <font-awesome-icon
                  icon="gift"
                  class="icon-color gray"/>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="105px"
          label="Created Date"
        >
          <template #default="{ row }">
            <div class="flex-algin time-text">
              <!--              <span>-->
              <span>{{ row.created_at.split(" ")[0] }}</span><br>
              <span> {{ row.created_at.split(" ")[1] }}</span>
              <!--              </span>-->
            </div>
          </template>

        </el-table-column>
        <el-table-column
          width="105px"
          label="Issued Date"
        >
          <template #default="{ row }">
            <div class="flex-algin time-text">
              <!--              <span>-->
              <span>{{ row.issuing_date}}</span><br>
              <span> {{ row.issuing_time }}</span>
              <!--              </span>-->
            </div>
          </template>

        </el-table-column>
        <el-table-column
          width="120px"
          label="Account name">
          <template #default="{ row }">
            <div class="flex-algin">
              <span class="span-name">{{ row.policy_holder }}</span>
              <span>
                <template v-if="row.identity == 2">
                  {{ row.contact_nm }}
                </template>
                <span class="phone-text"> {{ row.phone_no }}</span>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Gifts">
          <template #default="{row}">
            <div>
              <p class="color-dark fs-14">{{row.id_number}}</p>
              <p class="span-label">{{row.gift_nm}}</p>
            </div>
            <!--            <ul class="table-ul">-->
            <!--              <li class="flex-sb-center">-->
            <!--                <span class="dot">Eligible</span>-->
            <!--                <span>Pending</span>-->
            <!--              </li>-->
            <!--            </ul>-->
          </template>
        </el-table-column>
        <el-table-column
          label="Policy">
          <template #default="{ row }">
            <div
              class="flex-algin">
              <span class="span-label">{{ row.plan}}</span>
              <p
                class="time-text color-dark">
                Policy No.
              </p>
              <span
                v-if="row.order_sn"
                class="phone-text ">
                <template><span class="weight-text"> Ref. </span>{{ row.order_sn }}</template>
              </span>
              <p>
                <span class="liter-text tag-border">{{row.rgtn_no}}</span>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="155px"
          label="Status & Tag">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="status-height">
                <span
                  class="span-status"
                  :class="{
                    'red': [801, 0].includes(row.stts),
                    'orange': [401, 301].includes(row.stts),
                    'yellow-dark': [410, 501, 701].includes(row.stts),
                    'blue': [420, 505, 705].includes(row.stts),
                    'green': [425, 510, 710].includes(row.stts)
                  }">
                  {{ row.stts_language }}
                </span>
              </p>
              <p
                v-for="(v,i) in row.tag_language"
                :key="i"
                class="status-height">
                <span
                  class="span-options"
                  :class="{
                    'gold': v.id == 1,
                    'blue': [2,16,64,256].includes(v.id),
                    'orange': v.id == 4,
                    'black': [8,32,128].includes(v.id),
                    'red': [512].includes(v.id),
                    'gray': [1024, 2048].includes(v.id)
                  }">{{v.name}}</span>
              </p>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {getHanbergCashbackExportList, getHanbergCashbackList} from '@api/campaign'
import {mapActions, mapState} from 'vuex'
import {downloadFile} from '@/utils/download'

export default {
  name: 'Policy',
  mixins: [MixinOptions],
  props:{

  },
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      // todo
      date: [],
      company_id: [],
      referrer_code: '',
      class_id: [],
      category_id: [],
      stts: [],
      effe: [],
      tags: [],
      cs_id: 0,
      search: '',
      tableData: [],
      statusList: [],
      showFilterCard: true,
      source: [],
      defaultFilter:{
        date: [],
        issue_date: [],
        cs_id: 0,
        company_id: [],
        class_id: [],
        stts: [],
        effe: [],
        tags: [],
        source: [],
        partner_filter_id: [],
        effective_date: [],
      },
      paymentNum: 0,
      paymentMobileNum: 0,
      partner_filter_id: [],
      effective_date: [],
      issue_date: [],
      statistics:{
        total: {
          name: 'Total',
          val: 0
        },
        eligible: {
          name: 'Eligible',
          val: 0
        },
        reached: {
          name: 'Reached Target',
          val: 0
        },
        rewarded: {
          name: 'Rewarded',
          val: 0
        },
        caltex: {
          name: 'CALTEX Cashback',
          val: 0
        },
        esso: {
          name: 'Esso Cashback',
          val: 0
        },
      }
    }
  },
  computed: {
    ...mapState('filter', ['selectFilterData','openFilterCar']),
    selectName(){
      let name = this.getOptionName('productTypeList',this.selectPrivateOrAll)
      return name
    },

    isSelectPrivate(){
      return this.selectPrivateOrAll != 0
    },
    isDisable(){
      return !this.date || this.date.length == 0
    },
    statusOptions() {
      return this.globalOptions.new_pcy_stts
    },
    effeOptions() {
      return this.globalOptions.effectiveness
    },
    tagsOptions() {
      return this.globalOptions.pcy_tag
    },

    diff(){
      let res = false
      Object.keys(this.defaultFilter).forEach(key => {
        let vue_data = JSON.parse(JSON.stringify(this[key]))
        let default_data = JSON.parse(JSON.stringify(this.defaultFilter[key]))
        if(Array.isArray(vue_data) && Array.isArray(default_data)){
          vue_data.sort()
          default_data.sort()
        }
        if(JSON.stringify(vue_data) != JSON.stringify(default_data)){
          res =  true
        }
      })
      return res
    }
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        let {hanbergCashback={}} =  this.selectFilterData||{}
        Object.keys(hanbergCashback).forEach(item=>{
          this[item] = hanbergCashback[item]
        })
        this.setFilterData(hanbergCashback||{})
        let filterCar =  this.openFilterCar||{}
        let {showFilterCard=true} = filterCar.policy||{}
        this.showFilterCard = showFilterCard
        // if(this.date||this.issue_date||this.effective_date){
        //   this.$emit('changeDate',this.date||this.issue_date||this.effective_date)
        // }
        this.network().getHanbergCashbackList()
      }
    },
    date: {
      immediate: true,
      handler(val){
        this.delStatus('Created')
        if(val && val.length){
          let content = val[0] + ' - ' + val[1]
          this.addStutus('Created', content)
        }
        this.$emit('changeDate',this.date)
      }
    },
    cs_id:{
      immediate: true,
      handler(val){
        this.delStatus('Assignee')
        if(val){
          let name = this.getOptionName('assigneeList',val)
          this.addStutus('Assignee', name)
        }
      }
    },
    company_id:{
      immediate: true,
      handler(val){
        this.delStatus('Insurer')
        if(val.length){
          let company = []
          val.forEach(item => {
            company.push(this.getOptionName('insurerList', item))
          })
          this.addStutus('Insurer', company.join(', '))
        }
      }
    },
    source:{
      immediate: true,
      handler(val){
        this.delStatus('Channel')
        if(val.length){
          let status = []
          val.forEach(item => {
            status.push(this.getOptionName('channelList', item))
          })
          this.addStutus('Channel', status.join(', '))
        }
      }
    },
    class_id:{
      immediate: true,
      handler(val){
        this.delStatus('Product Type')
        if(val.length){
          this.addStutus('Product Type', `${val.length} Products`)
        }
      }
    },
    stts:{
      immediate: true,
      handler(val){
        this.delStatus('Status')
        if(val.length && JSON.stringify(val) != JSON.stringify(this.defaultFilter.stts)){
          let status = []
          val.forEach(item => {
            status.push(this.getOptionName('statusOptions', item))
          })
          this.addStutus('Status', status.join(', '))
        }
      }
    },
    effe:{
      immediate: true,
      handler(val){
        this.delStatus('Effectiveness')
        if(val.length){
          let status = []
          val.forEach(item => {
            status.push(this.getOptionName('effeOptions', item))
          })
          this.addStutus('Effectiveness', status.join(', '))
        }
      }
    },
    tags:{
      immediate: true,
      handler(val){
        this.delStatus('Tags')
        if(val.length){
          this.addStutus('Tags', `${val.length} Tags`)
        }
      }
    },
  },
  methods: {
    ...mapActions('filter', ['setFilterData','setOpenFilterCar']),

    handleTableClass(row, column, rowIndex, columnIndex){
      console.log(row, column, rowIndex, columnIndex)
      return 'tableHeader'
    },
    handleSelectPolicy({id}){
      this.selectPrivateOrAll = id
      this.pageConfig.currentPage =1
      this.network().getHanbergCashbackList()
    },
    handleSelect(){
      this.is_select = !this.is_select
    },
    handleShowFilter(){
      this.showFilterCard = !this.showFilterCard
      this.setOpenFilterCar({
        ...this.openFilterCar,
        policy:{
          showFilterCard:this.showFilterCard
        }
      })
    },
    handleSelectCar(){
      this.pageConfig.currentPage =1
      this.network().getHanbergCashbackList()
    },
    handlerDown() {
      this.network().getHanbergCashbackExportList()
    },
    rowClick(row) {
      const { id} = row
      let params = {
        stts:this.stts,
        search: this.search,
        date:this.date,
        pageConfig:this.pageConfig,
        effe: this.effe,
        tags: this.tags,
        effective_date: this.effective_date,
      }
      this.setFilterData({hanbergCashback:params})

      // this.$router.push(`/records/micropolicy/hanberg-cashback/${id}`)
    },
    handlerSelectAll(target) {
      let origin = ''
      switch(target) {
        case 'class_id':
          origin = 'classTypeOptions'
          break
        case 'stts':
          origin = 'statusOptions'
          break
        case 'effe':
          origin = 'effeOptions'
          break
        case 'tags':
          origin = 'tagsOptions'
          break
      }
      const data = this[origin].reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      this[target] = data

      this.filterData()
    },
    handlerNoneAll(target){
      this[target] = []
      this.filterData()
    },
    filterData() {
      this.pageConfig.currentPage = 1
      if(this.date||this.issue_date||this.effective_date){
        this.$parent.exportDisable = false
      }else {
        this.$parent.exportDisable = true
      }
      this.network().getHanbergCashbackList()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getHanbergCashbackList()
    },
    addStutus(title,content){
      this.statusList.push({
        title,
        content
      })
    },
    delStatus(title,content){
      // 把符合删除条件的元素都过滤掉
      let arr = []
      arr = this.statusList.filter(item => {
        return item.title !== title
      })
      this.statusList = JSON.parse(JSON.stringify(arr))
    },
    resetFilter(){
      Object.keys(this.defaultFilter).forEach(key => {
        this[key] = this.defaultFilter[key]
      })
      this.filterData()
    },
    network() {
      return {
        getHanbergCashbackList: async () => {
          let params = {
            created_start: this.date[0],
            created_end: this.date[1],
            issue_start: this.issue_date? this.issue_date[0]: '',
            issue_end: this.issue_date? this.issue_date[1]: '',
            class_id: this.class_id,
            stts: this.stts,
            search: this.search,
            page: this.pageConfig.currentPage,
            tag_id: this.tags,
            effe_id: this.effe,
            source: this.source,
            partner_filter_id: this.partner_filter_id,
            referrer_code: this.referrer_code,
            cmnt_dt: this.effective_date[0],
            expry_dt: this.effective_date[1],
          }
          const { data } = await getHanbergCashbackList(params)
          this.tableData = data.data
          this.pageConfig.total = data.total
          this.statistics.total.val = data.total
          // this.statistics.eligible.val = data.total
        },
        getHanbergCashbackExportList: async () => {
          let params = {
            created_start: this.date[0],
            created_end: this.date[1],
            issue_start: this.issue_date? this.issue_date[0]: '',
            issue_end: this.issue_date? this.issue_date[1]: '',
            class_id: this.class_id,
            stts: this.stts,
            search: this.search,
            page: this.pageConfig.currentPage,
            tag_id: this.tags,
            effe_id: this.effe,
            source: this.source,
            partner_filter_id: this.partner_filter_id,
            referrer_code: this.referrer_code,
            cmnt_dt: this.effective_date[0],
            expry_dt: this.effective_date[1],
          }
          const res = await getHanbergCashbackExportList(params)
          downloadFile(res)
        },
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  color: #303133;
  .total{
    //margin-bottom: 20px;
    .item{
      display: inline-block;
      margin-right: 20px;
      .num{
        font-size: 24px;
        font-weight: 400;
        line-height: 36px;
        padding: 0 10px;
      }
    }
    margin-bottom: 20px;
  }
  .mg-r-5{
    margin-right: 5px;
  }
  .time-text{
    font-size: 12px;
  }
  .table-ul{
    span{
      font-weight: 600;
      font-size: 12px;
      line-height: 18px;
      color: #6A737D;
      flex: 1;
      &.dot{
        position: relative;
        padding-left: 13px;
        &:before{
          content: '';
          width: 8px;
          height: 8px;
          border-radius: 100%;
          background: #D1D5DA;
          position: absolute;
          left: 0px;
          transform: translateY(50%);
        }
        &__green{
          &:before{
            background: #28A745;
          }
        }
      }
      &:last-child{
        font-weight: 400;
      }
    }
  }
  .flex-algin {
    /*display: flex;*/
    /*flex-direction: column;*/
    //justify-content: space-between;
    //font-weight: 500;
    &.time-text{
      font-size: 12px;
      color: #24292E;
    }
    .icon-text{
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      letter-spacing: -0.15px;
      color: #24292E;
      margin-left: 15px;
    }
    .phone-text{
      font-size: 12px;
      color: #6A737D;
      .weight-text{
        font-weight: 600;
      }
    }
    &.period-text{
      display: flex;
      flex-direction: column;
      span{
        font-size: 12px;
      }
      .asap{
        font-weight: bold;
        color: black;
        margin-left: 5px;
      }
    }
    p, span {
      min-height: 20px;
    }
    .first-text{
      color: #24292E;
      font-size: 14px;
    }
    .summary{
      font-size: 12px;
      word-break: break-word;
    }
    .status-height{
      height: 23px;
    }
  }
  .channel{
    font-size: 12px;
    font-weight: 600;
    color: #586069;
  }
  .table-icon{
    &.margin-top-flex{
      margin-top: 5px;
    }
    .icon{
      margin-right: 10px;
      img{
        height: 22px;
        width: 22px;
      }
    }
    .icon-content{
      height: 22px;
      width: 22px;
      border-radius: 5px;
      background-color: #E1E4E8;
      color: #6A737D;
      font-size: 14px;
      text-align: center;
      line-height: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #e1e4e8;
    }
    .backgroud-width{
      background: #fff!important;
      border: 1px solid #e1e4e8;
    }
  }
  .btn-top-container {
    position: absolute;
    top: 10px;
    right: 0;
  }
  .box-show__none{
    box-shadow: none;
    border: 1px solid #D1D5DA;
  }
  h1 {
    // margin-bottom: 20px;
    font-size: 34px;
  }
  .filter-container {
    .filter-box {
      margin-bottom: 10px;
      .label {
        display: block;
        padding-bottom: 5px;
        font-size: 14px;
        font-weight: bold;
        .all {
          display: inline-block;
          padding-left: 15px;
          color: #409eff;
          font-weight: 500;
          cursor: pointer;
        }
      }
      .search-box {
        margin-right: 20px;
        width: 400px;
      }
      .quote-box {
        width: 300px;
      }
    }

  }
  .span-name {
    display: block;
    color: #24292E;
    height: auto!important;
    font-size: 14px;
    word-break: break-word;
  }
  .span-label {
    display: block;
    color: #24292E;
    font-weight: 600;
    word-break: break-word;
    font-size: 14px;
    text-decoration: none;
    &:hover{
      color:  #0366D6;
    }
  }
  .half {
    flex: 1;
    & > span {
      display: block;
      padding-bottom: 5px;
      font-size: 14px;
      color: #6a737d;
    }
    /deep/.el-checkbox{
      .el-checkbox__label{
        font-size: 12px;
        color: #24292E;
      }
    }
  }
  .span-status, .span-options {
    display: inline-block;
    padding: 0px 8px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #FFFFFF;
    border-radius: 100px;
    max-width: 140px;
    word-break:keep-all;
    white-space:nowrap;
    height: 18px;
    min-height: 18px !important;
    .svg-inline--fa {
      margin-right: 5px;
      font-size: 14px;
    }
  }
  .span-status{
    &.green {
      background: #28a745;
      color: white;
    }
    &.orange {
      background: #E36209;
      color: white;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.red {
      background: #d73a49;
    }
    &.min-green {
      background: #dcffe4;
      color: #28a745;
    }
  }
  .span-options{
    border: 1px solid;
    &.gray {
      border-color: #586069;
      color: #586069;
    }
    &.green {
      border-color: #22863A;
      color: #22863A;
    }
    &.red {
      border-color: #D73A49;
      color: #D73A49;
    }
    &.gold {
      border-color: #735C0F;
      color: #735C0F;
    }
    &.blue {
      border-color: #0366D6;
      color: #0366D6;
    }
    &.orange {
      border-color: #C24E00;
      color: #C24E00;
    }
    &.black {
      border-color: #24292E;
      color: #24292E;
    }
  }
  .icon-color{
    &.gray {
      color: #6A737D;
    }
    &.green {
      color: #22863A;
    }
    &.red {
      color: #D73A49;
    }
  }
  .payment-tips{
    width: 100%;
    height: 64px;
    background: #FFFBDD;
    border: 1px solid rgba(176, 136, 0, 0.2);
    border-radius: 6px;
    color: #24292E;
    font-weight: 600;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    .tips-icon{
      color: #B08800;
    }
    .left{
      padding-left: 16px;
      .tips-icon{
        margin-right: 16px;
      }
    }
    .right{
      padding-right: 18px;
    }
  }
  .filter-top {
    margin-bottom: 14px;
  }
  .filter-bar{
    border: 1px solid #D1D5DA;
    height: 46px;
    padding: 11px 16px;
    background: #FFFFFF;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    white-space: nowrap;
    .icon{
      font-weight: 900;
      font-size: 14px;
      color: #586069;
    }
    .main-left{
      display: flex;
      overflow: hidden;
    }
    .left{
      margin-right: 15px;
      .icon-filter{
        margin-right: 11px;
      }
      .text{
        font-weight: 600;
        font-size: 14px;
      }
    }
    .filter-status{
      .status-item{
        height: 24px;
        padding: 4px 8px;
        background: #F1F8FF;
        border-radius: 100px;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        color: #0366D6;
        .content{
          font-weight: 600;
        }
        & + .status-item{
          margin-left: 18px;
        }
      }
    }
    .right{
      display: flex;
      align-items: center;
      position: relative;
      padding-left: 16px;
      .translucence{
        position: absolute;
        right: 100%;
        width: 15px;
        height: 44px;
        background: linear-gradient(90deg, rgba(219, 237, 255, 0) 0%, #DBEDFF 100%);
      }
      .right-cotent{
        background: #DBEDFF;
      }
      .icon-rotate{
        margin-right: 18px;
        color: #0366D6;
      }
    }
    &.blue-bg{
      background: #DBEDFF;
    }
  }
  .border-bottom-radius{
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  .filter-card {
    margin-bottom: 15px;
    background: white;
    border: 1px solid #E1E4E8;
    border-top: none;
    .filter-main {
      display: flex;
      padding: 0 15px;
      overflow-x: auto;
      .form-item{
        white-space: nowrap;
        /deep/.el-checkbox__label{
          white-space: nowrap;
        }
      }
      .all {
        display: inline-block;
        padding-left: 15px;
        color: #409eff;
        cursor: pointer;
      }
      .filter-left, .filter-middler, .filter-right, .filter-last {
        padding: 15px 0;
      }
      .filter-left {
        padding-right: 10px;
        width: 290px;
        flex: 1;

      }
      .left-border{
        border-left: 1px solid #E1E4E8;
      }
      .filter-middler {
        padding: 15px 10px;
        border-left: 1px solid #E1E4E8;
        border-right: 1px solid #E1E4E8;
        flex: 2;
      }
      .filter-right {
        padding: 15px 10px;
        border-right: 1px solid #E1E4E8;
        flex: 1;
      }
      .filter-last{
        padding-left: 10px;
        flex: 1;
      }
    }
    .circle {
      display: inline-block;
      margin-right: 5px;
      width: 14px;
      height: 14px;
      min-width: 14px;
      min-height: 14px;
      border-radius: 100%;
      &.orange-light {
        background: #E36209;
      }
      &.yellow-dark {
        background: #DBAB09;
      }
      &.blue {
        background: #0366D6;
      }
      &.green {
        background: #28A745;
      }

      &.red {
        background: #D73A49;
      }
    }
  }
  .purple {
    background: #6F42C1;
  }
}
.transparent{
  margin-top: 15px;
}
::v-deep .el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
  tr{
    td{
      //display: flex;
      padding: 10px 15px 10px 0!important;
      vertical-align: top;
      margin-right: 15px;
      //height: 40px;
      .cell{
        //min-height: 40px;
        line-height: 23px;
        position: relative;
        height: inherit;
        //margin-left: 10px;
        //margin-right: 10px;
        padding: 0;
        //padding: 5px 10px;
        //position: absolute;
        //top: 10px;
        .liter-text{
          color: #6A737D;
          font-size: 12px;
          &.tag-border{
            border: 1px solid #dddfe7;
            border-radius: 4px;
            text-align: center;
            padding: 2px 4px;
            line-height: 18px;
          }
        }
      }
    }
  }
}
::v-deep .tableHeader {
  margin-top: 30px;
  background: #F6F8FA !important;
  border-bottom: 1px solid #E1E4E8;

  th {
    background-color: #F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -0.15px;
    /* Text/text-gray-dark */
    padding: 10px 0!important;
    color: #24292E!important;
    .cell{
      padding-left: 0;
    }
  }
  .button-border{
    display: inline-block;
    padding: 0px 10px;
    height: auto;
    //line-height: 30px;
    font-size: 12px;
    border-radius: 50px;
    border: 1px solid #E1E4E8;
    color: #24292E;
    background: white;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;

  }
}
.showLick{
  text-decoration: none;
}

</style>
